import * as React from "react";

export const IconAutoRenew = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_6252_28743)">
			<path
				d="M10.0007 5.00065V7.50065L13.334 4.16732L10.0007 0.833984V3.33398C6.31732 3.33398 3.33398 6.31732 3.33398 10.0007C3.33398 11.309 3.71732 12.5257 4.36732 13.5507L5.58398 12.334C5.20898 11.6423 5.00065 10.8423 5.00065 10.0007C5.00065 7.24232 7.24232 5.00065 10.0007 5.00065ZM15.634 6.45065L14.4173 7.66732C14.784 8.36732 15.0007 9.15899 15.0007 10.0007C15.0007 12.759 12.759 15.0007 10.0007 15.0007L10.0007 12.5007L6.66732 15.834L10.0007 19.1673V16.6673C13.684 16.6673 16.6673 13.684 16.6673 10.0007C16.6673 8.69232 16.284 7.47565 15.634 6.45065Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_6252_28743">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
